import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IS_ONPREMISE } from 'reactApp/appHelpers/configHelpers';
import {
    aiPhotoGenerationDebugLogger,
    aiPhotoGenerationEnabled,
    aiPhotoGenerationPromoBanner,
} from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoGeneration';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { getAiPhotoGenerationPromoBannerHidden } from 'reactApp/ui/AiPhotoGeneration/Promo/Banner/AiPhotoGenerationPromoBanner.helpers';
import { ConditionsCheckType, getCheckAllConditions } from 'reactApp/utils/conditionChecker';

const aiPhotoGenerationCheckAllConditionsTrue = getCheckAllConditions(aiPhotoGenerationDebugLogger, ConditionsCheckType.FirstFalse);

export const useAiPhotoGenerationEntryPointBannerShow = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isBizUser = useSelector(UserSelectors.isBizUser);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);
    const isMobile = useSelector(EnvironmentSelectors.isMobile);
    const isOverquota = useSelector(UserQuotaSelectors.isOverquotaBySpaceAndApi);
    const isQuotaLoaded = useSelector(UserQuotaSelectors.isQuotaLoaded);
    const storage = useSelector(getCurrentStorage);
    const { isHome } = getStorage(storage);

    const dispatch = useDispatch();

    const [isHidden, setIsHidden] = useState<boolean>(true);

    useEffect(() => {
        setIsHidden(Boolean(dispatch(getAiPhotoGenerationPromoBannerHidden())));
    }, [dispatch]);

    const shouldShowBanner = aiPhotoGenerationCheckAllConditionsTrue('aiPhotoGenerationConnectedBanner', {
        isAiPhotoGenerationEnabled: aiPhotoGenerationEnabled,
        isAiPhotoGenerationBannerEnabled: aiPhotoGenerationPromoBanner,
        isNotHidden: !isHidden,
        isPageAllowed: isHome,
        isNotBiz: !isBizUser,
        isNotOnPrem: !IS_ONPREMISE,
        isNotCorp: !isCorpUser,
        isNotPaid: !isPaidUser,
        isNotOverquota: !isOverquota,
        isOverquotaLoaded: isQuotaLoaded,
        isNotMobile: !isMobile,
    });

    return {
        shouldShowBanner,
        setIsHidden,
    };
};
